import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../../assets/img/marifer.png";

const styles = StyleSheet.create({
  viewer: {
    width: "100%",
    height: window.innerHeight * 0.75,
  },
  page: {
    padding: 28,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  // ── Header ──────────────────────────────────
  header: {
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "2px solid #f43f5e",
    paddingBottom: 10,
    marginBottom: 16,
  },
  logoImg: {
    width: 55,
    height: 55,
    marginRight: 12,
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    color: "#f43f5e",
    marginBottom: 2,
  },
  headerSub: {
    fontSize: 8,
    color: "#9ca3af",
  },
  headerDate: {
    fontSize: 8,
    color: "#6b7280",
    marginTop: 2,
  },
  // ── Resumen ──────────────────────────────────
  summaryRow: {
    flexDirection: "row",
    gap: 8,
    marginBottom: 16,
  },
  summaryBox: {
    flex: 1,
    backgroundColor: "#fff0f6",
    borderRadius: 4,
    padding: 8,
    border: "1px solid #fce7f3",
    alignItems: "center",
  },
  summaryNum: {
    fontSize: 18,
    fontFamily: "Helvetica-Bold",
    color: "#f43f5e",
  },
  summaryLabel: {
    fontSize: 7,
    color: "#6b7280",
    marginTop: 2,
  },
  // ── Tabla ──────────────────────────────────
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f43f5e",
    borderRadius: 3,
    padding: "5px 6px",
    marginBottom: 2,
  },
  tableHeaderText: {
    color: "#fff",
    fontFamily: "Helvetica-Bold",
    fontSize: 7.5,
  },
  tableRow: {
    flexDirection: "row",
    padding: "4px 6px",
    borderBottom: "1px solid #fce7f3",
  },
  tableRowAlt: {
    flexDirection: "row",
    padding: "4px 6px",
    borderBottom: "1px solid #fce7f3",
    backgroundColor: "#fff0f6",
  },
  cellText: {
    fontSize: 8,
    color: "#374151",
  },
  // Anchos de columna
  colIdx:    { width: "5%" },
  colNombre: { width: "25%" },
  colCodigo: { width: "12%" },
  colDesc:   { width: "28%" },
  colPres:   { width: "15%" },
  colUnidad: { width: "10%" },
  colTipo:   { width: "5%" },
  // ── Footer ──────────────────────────────────
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 14,
    borderTop: "1px solid #fce7f3",
    paddingTop: 6,
  },
  footerText: {
    fontSize: 7,
    color: "#f472b6",
  },
});

const ReporteInsumosPdf = ({ insumos }) => {
  const data = insumos || [];
  const internos = data.filter((i) => i.internal).length;
  const externos = data.length - internos;

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        <Page style={styles.page} orientation="landscape">
          {/* Header */}
          <View style={styles.header}>
            <Image style={styles.logoImg} src={logo} />
            <View>
              <Text style={styles.headerTitle}>Catálogo de Habilitados</Text>
              <Text style={styles.headerSub}>Sistema de gestión Marifer</Text>
              <Text style={styles.headerDate}>
                Generado: {new Date().toLocaleDateString("es-MX")} — Total: {data.length} habilitados
              </Text>
            </View>
          </View>

          {/* Resumen */}
          <View style={styles.summaryRow}>
            <View style={styles.summaryBox}>
              <Text style={styles.summaryNum}>{data.length}</Text>
              <Text style={styles.summaryLabel}>Total habilitados</Text>
            </View>
            <View style={styles.summaryBox}>
              <Text style={styles.summaryNum}>{internos}</Text>
              <Text style={styles.summaryLabel}>Internos</Text>
            </View>
            <View style={styles.summaryBox}>
              <Text style={styles.summaryNum}>{externos}</Text>
              <Text style={styles.summaryLabel}>Externos</Text>
            </View>
          </View>

          {/* Encabezado tabla */}
          <View style={styles.tableHeader}>
            <Text style={[styles.tableHeaderText, styles.colIdx]}>#</Text>
            <Text style={[styles.tableHeaderText, styles.colNombre]}>Nombre</Text>
            <Text style={[styles.tableHeaderText, styles.colCodigo]}>Código</Text>
            <Text style={[styles.tableHeaderText, styles.colDesc]}>Descripción</Text>
            <Text style={[styles.tableHeaderText, styles.colPres]}>Presentación</Text>
            <Text style={[styles.tableHeaderText, styles.colUnidad]}>Unidad</Text>
            <Text style={[styles.tableHeaderText, styles.colTipo]}>Int.</Text>
          </View>

          {/* Filas */}
          {data.map((item, i) => {
            const RowStyle = i % 2 === 0 ? styles.tableRow : styles.tableRowAlt;
            return (
              <View key={item.id || i} style={RowStyle}>
                <Text style={[styles.cellText, styles.colIdx]}>{i + 1}</Text>
                <Text style={[styles.cellText, styles.colNombre]}>{item.nombre || ""}</Text>
                <Text style={[styles.cellText, styles.colCodigo]}>{item.codigo || ""}</Text>
                <Text style={[styles.cellText, styles.colDesc]}>{item.descripcion || ""}</Text>
                <Text style={[styles.cellText, styles.colPres]}>{item.details?.presentacion || ""}</Text>
                <Text style={[styles.cellText, styles.colUnidad]}>{item.unit_base || ""}</Text>
                <Text style={[styles.cellText, styles.colTipo]}>{item.internal ? "Sí" : "No"}</Text>
              </View>
            );
          })}

          {/* Footer */}
          <View style={styles.footer}>
            <Text style={styles.footerText}>©Marifer {new Date().getFullYear()}</Text>
            <Text style={styles.footerText}>
              {new Date().toLocaleDateString("es-MX")} — Catálogo de Habilitados
            </Text>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default ReporteInsumosPdf;
